#import "../../../../graphql-wrappers/graphql/fragments/audience-fragment.graphql"

mutation UpdateSMSBroadcast($input: SmsEditionUpdateInput!) {
    smsEditionUpdate(input: $input) {
        edition {
            id
            name
            content
            campaign {
                id
                name
                deletedTime
                type
                owner {
                    id
                    name
                }
            }
            optOutText
            audience {
                ...AudienceFragment
            }
        }
    }
}
